import React from 'react';

const ciamStyle = {
  backgroundColor: '#C879B2',
  width: 46,
  height: 30,
  display: 'inline-block',
  color: '#F5F7F9',
  borderRadius: 3,
  textAlign: 'center',
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'uppercase',
  padding: 7
};

const ciamSVG = () =>
  <span style={ciamStyle}>
    ciam
  </span>;

export default ciamSVG;



// WEBPACK FOOTER //
// ./src/svg/ciamSVG.js